import type { SVGProps } from 'react'

export function Lock(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M9.23047 10H7.2002C6.08009 10 5.51962 10 5.0918 10.218C4.71547 10.4097 4.40973 10.7155 4.21799 11.0918C4 11.5196 4 12.0801 4 13.2002V17.8002C4 18.9203 4 19.4801 4.21799 19.9079C4.40973 20.2842 4.71547 20.5905 5.0918 20.7822C5.5192 21 6.07902 21 7.19694 21H16.8031C17.921 21 18.48 21 18.9074 20.7822C19.2837 20.5905 19.5905 20.2842 19.7822 19.9079C20 19.4805 20 18.9215 20 17.8036V13.1969C20 12.079 20 11.5192 19.7822 11.0918C19.5905 10.7155 19.2837 10.4097 18.9074 10.218C18.4796 10 17.9203 10 16.8002 10H14.7689M9.23047 10H14.7689M9.23047 10C9.10302 10 8 9.89668 8 9.76923V6C8 4 10.3431 3 12 3C13.6569 3 16 4 16 6V9.76923C16 9.89668 14.8964 10 14.7689 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}
